import React from 'react';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Heading, Table, Card } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { normalizeDecimalInputValue } from 'src/common/utils/decimal-input';
import { createInitialBranch } from 'store/entities/templates/templates';
import {
  getBranchHeaderRow,
  getBranchRowsParams,
  getBranchUnitRow,
} from 'src/views/activity-model/tasks/branch-table-utils';

const BranchesTable = ({ branches, setBranches, branchesErros, riskId, estimateType, distributionType }) => {
  const { t } = useTranslation();

  const onAddBranch = (parentId) => {
    const newBranch = createInitialBranch(parentId);
    setBranches((prev) => [...prev, newBranch]);
  };

  const onDeleteBranch = (id) => {
    setBranches((prev) => prev.filter((risk) => risk.id !== id));
  };

  const onChangeBranch = (value, field, branchId) => {
    setBranches((prev) => {
      const branchIndex = prev.findIndex((branch) => branch.id === branchId);
      const updatedBranches = cloneDeep(prev);
      if (branchIndex !== -1) {
        updatedBranches[branchIndex][field] = value;
      }
      return updatedBranches;
    });
  };

  const rowsParams = getBranchRowsParams({
    t,
    estimateType,
    distributionType,
  });
  const headerRow = getBranchHeaderRow(rowsParams);
  const unitRow = getBranchUnitRow(rowsParams);

  const actions = [
    {
      label: t(translations.add),
      primary: true,
      icon: 'add',
      onClick: () => onAddBranch(riskId),
    },
  ];

  const tableRows = branches.map((branch, index) => {
    const errors = branchesErros?.[index];
    const cells = rowsParams.map(({ key }) => {
      const value = branch[key];
      const error = t(errors?.[key]);

      return {
        type: key === 'name' ? 'Input' : 'NumberInput',
        name: key,
        value,
        error,
        onChange: (e) => {
          const replaceComasToDotValue =
            key === 'name' ? e.target.value.replace(/,/, '.') : normalizeDecimalInputValue(e.target.value);
          onChangeBranch(replaceComasToDotValue, key, branch.id);
        },
      };
    });

    return {
      cells,
      actions: [
        {
          label: t(translations.delete),
          icon: 'minus',
          onClick: () => onDeleteBranch(branch.id),
        },
      ],
    };
  });

  const table = {
    bordered: false,
    headers: [{ cells: headerRow, actions }, { cells: unitRow }],
    rows: tableRows,
    footer: {},
  };

  return (
    <>
      <Card
        heading={
          <Heading>
            {t(translations.branches)}
            {branches.length ? ` (${branches.length})` : null}
          </Heading>
        }
        padding={0}
      >
        <Table table={table} />
      </Card>
    </>
  );
};

export { BranchesTable };
